import React from "react";
import { Anchor } from "discover.medical.react-component-library";

export const SignInNow = ({ onFormChange }) => {
  return (
    <Anchor
      id="other-link"
      href="#"
      onClick={onFormChange}
    >
      Sign in now
    </Anchor>
  );
};

export default SignInNow;
